/**
 * Roles seed (prototype screens 14/15/16): two system roles and three custom
 * roles. A role grants `permissions: [{ permission_id, level }]` from the studios
 * catalog; `studios` are the tags shown on the role card.
 */

const grants = (level, ...ids) => ids.map((permission_id) => ({ permission_id, level }));
const ROLE_DATE = (daysAgo) => new Date(Date.now() - daysAgo * 86_400_000).toISOString();

export const SYSTEM_ROLE_IDS = ['role-developer', 'role-viewer'];

export const buildSeedRoles = () => [
  {
    id: 'role-developer',
    name: 'Developer',
    type: 'system',
    description: 'Build and deploy integrations, agents, and custom workflows.',
    studios: ['governance', 'data', 'agentic'],
    permissions: [
      ...grants(
        'own',
        'governance.sandboxes.view',
        'governance.sandboxes.details',
        'governance.sandboxes.view_claims',
        'governance.sandboxes.manage_bundles',
        'governance.sandboxes.connect_sources',
        'governance.sandboxes.promote',
        'agentic.workers.create',
        'agentic.workers.deploy',
        'agentic.networks.build',
        'agentic.networks.run',
        'data.datasets.create'
      ),
      ...grants(
        'tenant',
        'governance.drives.view.browse',
        'agentic.workers.view',
        'data.datasets.view'
      ),
    ],
    created_at: ROLE_DATE(400),
    updated_at: ROLE_DATE(400),
  },
  {
    id: 'role-viewer',
    name: 'Viewer',
    type: 'system',
    description: 'Read-only access across all non-sensitive studio content.',
    studios: ['governance', 'data', 'agentic'],
    permissions: [
      ...grants(
        'tenant',
        'governance.drives.view.browse',
        'data.datasets.view',
        'agentic.workers.view'
      ),
      ...grants(
        'own',
        'governance.sandboxes.view',
        'governance.truth_plane.view',
        'governance.promotion_packs.view'
      ),
    ],
    created_at: ROLE_DATE(400),
    updated_at: ROLE_DATE(400),
  },
  {
    id: 'role-agent-builder',
    name: 'Agent Builder',
    type: 'custom',
    description: 'Create and manage AI workers, agentic networks, and workflow definitions.',
    studios: ['agentic'],
    permissions: [
      ...grants(
        'own',
        'agentic.workers.create',
        'agentic.workers.deploy',
        'agentic.networks.build',
        'agentic.networks.run',
        'agentic.htl_packs.manage'
      ),
      ...grants(
        'tenant',
        'agentic.workers.view',
        'agentic.networks.view',
        'agentic.htl_packs.view'
      ),
    ],
    created_at: ROLE_DATE(210),
    updated_at: ROLE_DATE(95),
  },
  {
    id: 'role-data-steward',
    name: 'Data Steward',
    type: 'custom',
    description: 'Manage model definitions, governance policies, and data lineage graphs.',
    studios: ['governance', 'data'],
    permissions: [
      ...grants(
        'own',
        'data.models.author',
        'data.models.publish',
        'data.lineage.edit',
        'governance.truth_plane.edit'
      ),
      ...grants('groups', 'data.datasets.schemas', 'governance.truth_plane.approve'),
      ...grants('tenant', 'data.models.view', 'data.lineage.view', 'data.datasets.view'),
    ],
    created_at: ROLE_DATE(180),
    updated_at: ROLE_DATE(60),
  },
  {
    id: 'role-compliance-auditor',
    name: 'Compliance Auditor',
    type: 'custom',
    description:
      'Read-only access to governance truth, packs, models, data lineage and AI workers.',
    studios: ['governance', 'data', 'agentic'],
    permissions: grants(
      'tenant',
      'governance.truth_plane.view',
      'governance.promotion_packs.view',
      'data.models.view',
      'data.lineage.view',
      'agentic.workers.view'
    ),
    created_at: ROLE_DATE(120),
    updated_at: ROLE_DATE(120),
  },
];
